import { BOOKING_SLUG } from '../api/constants';
import NavBar from '../components/common/NavBar';
import NewHeaderComponent from '../components/common/NewHeaderComponent';

export default function AddEkaCredits(): JSX.Element | null {
    const src = `${BOOKING_SLUG}/eka-credits/medium-plan`;
    return (
        <div className="grid h-full overflow-x-auto overflow-y-hidden grid-cols-queueGrid min-w-840 undefined">
            <NavBar />
            <div className="flex flex-col h-full col-span-11 overflow-hidden">
                <NewHeaderComponent title="Add Eka Credits" />
                <iframe height="100%" width="100%" src={src}></iframe>
            </div>
        </div>
    );
}
